var _circle, _circle2, _g, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWheelSpinIconActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#FF7676"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2030_2547",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 18,
    height: 18
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 9,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2030_2547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0254 14.9751L11.5004 6.52515L11.5 4.875H17.2502L18.8004 5.82515L15.0254 14.9751Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0503 14.9748C17.7961 13.8206 23.3778 11.4973 23.4378 11.4873L24.7501 11.25L25.1251 18L23.6503 18.5373L15.0503 14.9748Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0254 15.0117L11.4629 23.6867L12.0001 24.7493H17.2501C17.3301 24.7493 18.3751 24.7493 18.6254 23.6867L15.0254 15.0117Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 14.9883L6.325 11.4258L5.24963 11.6775C5.24963 12.4692 5.17427 16.3742 5.24963 16.875C5.34358 17.4992 5.24963 18.5883 6.325 18.5883L15 14.9883Z",
    stroke: "white"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 8.5,
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelSpinIconActive);
export default __webpack_public_path__ + "static/media/wheelSpin_icon--active.3f9b5126ebc6c1341b3a7fd56a7b37d8.svg";
export { ForwardRef as ReactComponent };